import get from "lodash/fp/get";
import { RootState } from "../types";
import { SFunctionTemplatesSlice } from "./reducers/types";
import { FlowioFunctionId, TemplateId } from "../../globalTypes";

// Slice
export const getFunctionTemplatesSlice = (
  state: RootState
): SFunctionTemplatesSlice => state.functionTemplates;

export const getByTemplateId = (state: RootState) =>
  getFunctionTemplatesSlice(state).byTemplateId;

export const getFunctionTemplatesForTemplateId = (
  state: RootState,
  id: TemplateId | null | undefined
) => {
  if (!id) return undefined;
  return get(`functionTemplates`, getByTemplateId(state)[id]);
};

export const getFunctionTemplate = (
  state: RootState,
  templateId: TemplateId | null | undefined,
  functionId: FlowioFunctionId
) => {
  const functionTemplates = getFunctionTemplatesForTemplateId(
    state,
    templateId
  );

  return functionTemplates?.[functionId];
};

export const getAreFunctionTemplatesFetchingForTemplateId = (
  s: RootState,
  templateId: TemplateId
) => getByTemplateId(s)[templateId]?.isFetching;
